export default __webpack_public_path__ + "static/media/Tendring_District_Council.d787e856.svg";